import React, { useEffect } from "react";
import { Form, InputNumber } from "antd";

const Price = ({ state = {}, readOnly, placeholder, style = {}, ...props }) => {
  const { data, form, rules, onChange } = state;

  // Sync antd form with state
  useEffect(() => {
    form?.setFieldsValue({ price: data });
  }, [data]);

  return (
    <Form form={form} style={{ width: "100%",...style }}>
      <Form.Item name="price" rules={rules}>
        <InputNumber
          size="large"
          min={0}
          value={data}
          addonBefore="$"
          style={{ fontSize: style?.inputFontSize || "16px", width: "100%" }}
          onChange={onChange}
          readOnly={readOnly}
          placeholder={placeholder || "Price"}
          {...props}
        />
      </Form.Item>
    </Form>
  );
};

export default Price;
